var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreloaderInnerCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.9822 58.9268C85.619 41.2282 76.6516 21.5005 58.953 14.8638C41.2544 8.22703 21.5267 17.1944 14.8899 34.8931C8.25319 52.5917 17.2206 72.3194 34.9192 78.9561C52.6178 85.5928 72.3455 76.6254 78.9822 58.9268Z",
    stroke: "#00E0FF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeDasharray: "1 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreloaderInnerCircle);
export default __webpack_public_path__ + "static/media/preloader-inner-circle.eead99dd.svg";
export { ForwardRef as ReactComponent };